import { useFixerContent } from '../hooks/i18n/usePageContent.js'
import type { FutureDotGlyph } from './future-chat/FutureDotPrimitives.js'
import { FutureDotMatrixIcon } from './future-chat/FutureDotPrimitives.js'

const HIGHLIGHT_GLYPHS: Record<string, FutureDotGlyph> = {
  logistics: 'export',
  locations: 'location',
  crew: 'memory',
}

export function FixerHeroHighlights() {
  const c = useFixerContent()
  return (
    <div className="fixer-hero-highlights flex flex-col gap-3 lg:max-w-[340px]">
      {c.heroHighlights.map((item, index) => (
        <div
          key={item.id}
          className="fixer-glass-card flex gap-4"
          style={{ animationDelay: `${0.35 + index * 0.1}s` }}
        >
          <div className="fixer-accent-icon">
            <FutureDotMatrixIcon
              glyph={HIGHLIGHT_GLYPHS[item.id] ?? 'signal'}
              state="signal"
              size={20}
            />
          </div>
          <div className="flex min-w-0 flex-col gap-1">
            <h3 className="fixer-subheading text-white">{item.title}</h3>
            <p className="text-xs leading-relaxed text-white/75">{item.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}
